const BaseURL = {
  BASE_URL: `${process.env.REACT_APP_BASE_URL}`,
};

export const API_CONSTANTS = {
  //Account Section
  LOGIN: `${BaseURL.BASE_URL}/Account/Login`,
  REGISTER: `${BaseURL.BASE_URL}/Account/Register`,
  FORGOT_PASSWORD: `${BaseURL.BASE_URL}/Account/ForgotPassword`,
  VALIDATE_URL: `${BaseURL.BASE_URL}/Account/ValidateResetUrl`,
  VALIDATE_OTP: `${BaseURL.BASE_URL}/Account/ValidateOtp`,
  VALIDATE_OTP: `${BaseURL.BASE_URL}/Account/ValidateOtp`,
  CONTACT_SUPPORT: `${BaseURL.BASE_URL}/ContactSupport/ContactSupport`,
  RESET_PASSWORD: `${BaseURL.BASE_URL}/Account/ResetPassword`,

  //Learner Management
  LEARNER_DASHBOARD: `${BaseURL.BASE_URL}/LearnerManagment/LearnerDashBoard`,
  GET_ALL_LEARNERS: `${BaseURL.BASE_URL}/LearnerManagment/GetAllLearners`,
  ADD_LEARNER: `${BaseURL.BASE_URL}/LearnerManagment/AddLearner`,
  DOWNLOAD_LEARNER_EXCEL: `${BaseURL.BASE_URL}/LearnerManagment/DownloadSampleExcelFile`,
  BATCH_UPLOAD_EXCEL: `${BaseURL.BASE_URL}/LearnerManagment/BatchUploadLearner`,
  GET_LEARNERS_BY_ID: `${BaseURL.BASE_URL}/LearnerManagment/GetLearnerById`,
  REMOVE_LEARNER: `${BaseURL.BASE_URL}/LearnerManagment/RemoveLearners`,
  UPDATE_LEARNER: `${BaseURL.BASE_URL}/LearnerManagment/UpdateLearner`,
  REVOKE_BADGE_FROM_LEARNER: `${BaseURL.BASE_URL}/LearnerManagment/RevokeBadgeFromLearner`,
  REMOVE_BADGE: `${BaseURL.BASE_URL}/LearnerManagment/RemoveBadge`,
  REMOVE_PROFILE_PICTURE: `${BaseURL.BASE_URL}/LearnerManagment/RemoveProfilePicture`,

  //Staff
  GET_ALL_STAFF: `${BaseURL.BASE_URL}/Staff/GetAllStaff`,
  ARCHIVED_STAFFS: `${BaseURL.BASE_URL}/Staff/ArchivedStaffs`,
  DELETE_STAFF: `${BaseURL.BASE_URL}/Staff/DeleteStaff`,
  ADD_STAFF: `${BaseURL.BASE_URL}/Staff/AddStaff`,
  UPDATE_STAFF: `${BaseURL.BASE_URL}/Staff/UpdateStaff`,
  GET_STAFF_BY_ID: `${BaseURL.BASE_URL}/Staff/GetStaffById`,
  APPROVE_BADGE: `${BaseURL.BASE_URL}/Staff/ApproveBadge`,

  //Credential
  GET_ALL_BADGES: `${BaseURL.BASE_URL}/Badge/GetAllBadges`,
  GET_UNAPPROVED_BADGES: `${BaseURL.BASE_URL}/Badge/GetUnApprovedBadges`,
  DELETE_BADGE: `${BaseURL.BASE_URL}/Badge/DeleteBadge`,
  ASSIGN_BADGES: `${BaseURL.BASE_URL}/Badge/AssignBadges`,
  ADD_BADGE: `${BaseURL.BASE_URL}/Badge/AddBadge`,
  UPDATE_BADGE: `${BaseURL.BASE_URL}/Badge/UpdateBadge`,
  GET_BADGE_PICTURES: `${BaseURL.BASE_URL}/Badge/GetBadgePictures`,
  GET_BADGE_BY_ID: `${BaseURL.BASE_URL}/Badge/GetBadgeById`,
  BADGE_FACTORY_DASHBOARD: `${BaseURL.BASE_URL}/Badge/BadgeFactoryDashBoard`,


  //Dropdowns
  GET_BADGE_SORT_OPTIONS: `${BaseURL.BASE_URL}/DropDown/GetBadgeSortOptions`,
  GET_ALL_DEPARTMENT: `${BaseURL.BASE_URL}/DropDown/GetAllDepartment`,
  GET_ALL_ACCESSLEVEL: `${BaseURL.BASE_URL}/DropDown/GetAllAccessLevel`,
  GET_BADGE_SEQUENCE: `${BaseURL.BASE_URL}/DropDown/GetBadgeSequence`,
  GET_ALL_APPROVAL_USERS: `${BaseURL.BASE_URL}/DropDown/GetAllApprovalUsers`,
  GET_LEARNERS_FOR_BADGE_ASSIGN: `${BaseURL.BASE_URL}/DropDown/GetLearnersForBadgeAssign`,
  GET_DELETED_USER_SORT_OPTIONS: `${BaseURL.BASE_URL}/DropDown/GetDeletedUserSortOptions`,
  GET_ALL_BADGETYPE: `${BaseURL.BASE_URL}/DropDown/GetBadgeType`,
  GET_ALL_STAFFSORT: `${BaseURL.BASE_URL}/DropDown/GetStaffSortOptions`,



  //Settings
  CHANGE_PASSWORD: `${BaseURL.BASE_URL}/Settings/ChangePassword`,
  GET_ALL_DELETED_USER: `${BaseURL.BASE_URL}/Settings/GetAllDeletedUser`,

  //Department
  ADD_DEPARTMENT: `${BaseURL.BASE_URL}/Department/AddDepartment`,
};

export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  UPDATE: "UPDATE",
  PUT: "PUT",
};
